import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Item from './Item';

const renderEvents = (events) =>
  events.map((e) => <Item key={e._id} event={e} />);

const List = ({ events, goalMemos, t }) => {
  return (
    <React.Fragment>
      <h3>
        <span className="u-color-fountain-blue">
          {t('manageUpdates.goalsTitlePrefix')}
        </span>
        {t('manageUpdates.goalsTitle')}
        <span className="u-color-fountain-blue">
          {t('manageUpdates.goalsTitleSuffix')}
        </span>
      </h3>
      {events.length ? (
        <div className="c-box c-box-primary">{renderEvents(events, t)}</div>
      ) : (
        <React.Fragment>
          <p className="u-weight-light">{t('manageUpdates.noGoalUpdates')}</p>
          <Link to="/my-profile" className="c-btn c-btn-outline">
            {t('general.goGoals')}
          </Link>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state, { userEvents }) => ({
  events: userEvents.filter(({ action }) =>
    [
      'ADD_GOAL',
      'COMPLETE_GOAL',
      'UNCOMPLETE_GOAL',
      'REMOVE_GOAL',
      'ADD_GOAL_MEMO',
    ].includes(action)
  ),
});

export default connect(mapStateToProps)(translate()(List));



// WEBPACK FOOTER //
// ./src/updates/user-updates/goals/List.js